import $ from 'jquery';

function PodMods(element) {
  this.element = element;
  this.$element = $(element);
  this.init();
  this.ready();
}

PodMods.prototype = {
  init() { this.$element.find('.node-upper-image').insertBefore(this.$element.find('.node-inner')); },
  ready() { this.$element.addClass('ready'); },
};

export default PodMods;
